import { call, put, takeLatest, all } from 'redux-saga/effects';
import Swal from 'sweetalert2';
import * as types from './actionTypes';
import { post } from '../../../helpers/api_helper';

// 🚀 Fetch Saga
function* fetchKeysResponsibilitiesSaga(action) {
  const { unit_id } = action.payload;
  try {
    const formData = new FormData();
    formData.append('unit_id', unit_id);

    const response = yield call(post, process.env.REACT_APP_FETCH_KEYS_RESPONSIBILITIES, formData);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to fetch Keys & Responsibilities!');
    }

    yield put({ type: types.FETCH_KEYS_RESPONSIBILITIES_SUCCESS, payload: response });
  } catch (error) {
    Swal.fire({
      title: 'Error',
      text: error.message || 'Something went wrong while fetching!',
      icon: 'error',
      confirmButtonText: 'OK',
    });

    yield put({ type: types.FETCH_KEYS_RESPONSIBILITIES_FAILURE, payload: error });
  }
}

// 💾 Save Saga
function* saveKeysResponsibilitiesSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_SAVE_KEYS_RESPONSIBILITIES, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to save Keys & Responsibilities!');
    }

    yield put({ type: types.SAVE_KEYS_RESPONSIBILITIES_SUCCESS, payload: response });
    Swal.fire('Success', response?.message, 'success');
  } catch (error) {
    Swal.fire({
      title: 'Error',
      text: error.message || 'Something went wrong while saving!',
      icon: 'error',
      confirmButtonText: 'OK',
    });

    yield put({ type: types.SAVE_KEYS_RESPONSIBILITIES_FAILURE, payload: error });
  }
}

// 🔄 Change Status Saga
function* changeKeysResponsibilitiesStatusSaga(action) {
  try {

    const response = yield call(post, process.env.REACT_APP_CHANGE_KEYS_RESPONSIBILITIES_STATUS, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to change status!');
    }

    yield put({ type: types.CHANGE_KEYS_RESPONSIBILITIES_STATUS_SUCCESS, payload: response });
    Swal.fire('Success', 'Status updated!', 'success');
  } catch (error) {
    Swal.fire({
      title: 'Error',
      text: error.message || 'Something went wrong while updating status!',
      icon: 'error',
      confirmButtonText: 'OK',
    });

    yield put({ type: types.CHANGE_KEYS_RESPONSIBILITIES_STATUS_FAILURE, payload: error });
  }
}

// 🔄 Root Saga
export default function* keysResponsibilitiesSaga() {
  yield all([
    takeLatest(types.FETCH_KEYS_RESPONSIBILITIES, fetchKeysResponsibilitiesSaga),
    takeLatest(types.SAVE_KEYS_RESPONSIBILITIES, saveKeysResponsibilitiesSaga),
    takeLatest(types.CHANGE_KEYS_RESPONSIBILITIES_STATUS, changeKeysResponsibilitiesStatusSaga),
  ]);
}
